<template>
    <div class="discount-credentials-details">
      <div class="page-content">
        <img v-if="showLogo" class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFile}`)">
        <slot name="title"/>
        <div v-if="!hasTitleSlot" class="title">
          חיבור חשבון דיסקונט בצורה מהירה ומאובטחת <span class="bold">ישירות דרך אתר דיסקונט:</span>
        </div>
        <ValidationObserver ref="observer" slim>
        <credentials-input-field class="input-container"
                                 :field-name="'של מי החשבון? (שם)'"
                                 :validations="'min-length:2'"
                                 :error="nameAlreadyUsedError"
                                 :error-message="nameAlreadyUsedErrorMessage"
                                 :field-type="'text'"
                                 :field-value="name"
                                 :update-input="updateName"/>
        <div v-for="(field, fieldKey) in source.fields" :key="fieldKey">
          <credentials-input-field v-if="field.type !== 'password'"
                                   ref="field"
                                   class="input-container"
                                   :field-name="field.name"
                                   :field-value="credentials[fieldKey]"
                                   :update-input="updateCredentials(fieldKey)"
                                   :field-type="field.type"
                                   :validations="field.validation"/>
          <credentials-input-field v-else
                                   ref="field"
                                   class="input-container"
                                   :field-name="field.name"
                                   :field-type="field.type"
                                   :field-value="credentials[fieldKey]"
                                   :validations="field.validation"
                                   :update-input="updateCredentials(fieldKey)"/>
        </div>
        </ValidationObserver>
        <div class="button-wrapper">
          <riseup-button
            class="save-button"
            :variant="'discount'"
            :disabled="!buttonEnabled"
            :title="'המשך לאתר דיסקונט'"
            :action="saveDiscountDirect"
            :size="'small'"/>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUi from 'base-ui';
import _ from 'lodash';
import CredentialsInputField from '../CredentialsInputField.vue';
import RedirectToDiscountPopup from './RedirectToDiscountPopup.vue';
import Segment from '../../../Segment';

export default {
  name: 'DiscountCredentialsDetails',
  components: {
    CredentialsInputField,
    RiseupButton: BaseUi.RiseupButton,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    nameAlreadyUsedError: {
      type: Boolean,
      default: false,
    },
    setNameAlreadyInUseError: {
      type: Function,
    },
    saveDiscountCredentials: {
      type: Function,
      required: true,
    },
    validateName: {
      type: Function,
      required: true,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      credentials: {},
      name: '',
      showError: false,
    };
  },
  computed: {
    isValidName() {
      return this.name.length > 1;
    },
    nameAlreadyUsedErrorMessage() {
      return this.nameAlreadyUsedError ? 'כבר השתמשת בשם הזה' : null;
    },
    allFieldsHaveInput() {
      return _.every(_.keys(this.source.fields), fieldKey => this.credentials[fieldKey] && this.credentials[fieldKey].length > 3);
    },
    buttonEnabled() {
      return this.isValidName && this.allFieldsHaveInput;
    },
    hasTitleSlot() {
      return !!this.$slots.title;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    updateCredentials(fieldKey) {
      return value => {
        this.$set(this.credentials, fieldKey, value);
      };
    },
    updateName(name) {
      this.name = name;
      this.setNameAlreadyInUseError(false);
    },
    async saveDiscountDirect() {
      this.showError = true;
      Segment.trackUserInteraction('DiscountConnectClicked');
      await this.validateName({ sourceName: this.source.sourceName, name: this.name });
      const valid = await this.$refs.observer.validate();
      _.forEach(this.$refs.field, field => field.validate());
      if (valid && !this.nameAlreadyUsedError) {
        this.openModal({
          component: RedirectToDiscountPopup,
          props: {
            saveDiscountCredentials: this.saveDiscountCredentials,
            idNumber: this.credentials.idNumber,
            name: this.name,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .discount-credentials-details {
    width: 100%;

    .error-bar {
      @include responsive-padding;
    }

    .page-content {
      padding: 30px;
      @include responsive-padding;

      .logo-image {
        height: 40px;
        margin-bottom: 20px;
      }

      .title {
        color: $riseup_black;
        font-size: 18px;
        line-height: 1.44;
        margin-bottom: 30px;

        .bold {
          font-weight: bold;
        }
      }

      .tool-tip-wrapper {
        margin-bottom: 35px;
      }

      .input-container {
        margin-bottom: 30px;
      }

      .button-wrapper {
        .save-button {
          width: 100%;
        }
      }
    }
  }

</style>
